import { useInAppNotificationsStore } from "@shared/stores/inAppNotificationsStore.ts";
import { inAppNotificationsService } from "@shared/services/inAppNotifications.ts";
import logger from "@shared/utils/logger.ts";

export default () => {
  const inAppNotificationsStore = useInAppNotificationsStore();
  const startInAppNotificationListening = async (loggedInEmail: string) => {
    try {
      const eventChannel = await inAppNotificationsService.getEventChannel();

      if (eventChannel.email !== loggedInEmail) {
        throw new Error(
          `received eventChannel '${eventChannel.channel}' is not matching the requested email '${loggedInEmail}'`,
        );
      }

      inAppNotificationsStore.setEventChannel(eventChannel.channel);
    } catch (e) {
      // no need to display notification toast here
      logger.error(e);
    }
  };
  const stopInAppNotificationListening = async () => {
    try {
      const eventChannel = inAppNotificationsStore.eventChannel;
      if (!eventChannel) {
        return;
      }
      // here we should stop to listen to websocket
    } catch (e) {
      // no need to display notification toast here
      logger.error(e);
    }
  };

  return {
    startInAppNotificationListening,
    stopInAppNotificationListening,
  };
};
